<script setup>
import { computed } from 'vue';

const props = defineProps({
	manufacturerData: {
		type: Object,
		required: true,
	},
	isBasket: {
		type: Boolean,
		default: false,
	},
});

const basketClass = computed(() => props.isBasket ? "c-manufacturer-image--basket" : "");
const manufacturerImageUrl = computed(() => props.manufacturerData.DefaultProductImagePath || props.manufacturerData.ManufactureIconUrl)

</script>

<template>
	<div class="c-manufacturer-image" :class="basketClass" v-if="manufacturerImageUrl">
		<figure class="c-manufacturer-image__figure">
			<img
				class="c-manufacturer-image__logo"
				:src="manufacturerImageUrl"
				loading="lazy"
				:alt="manufacturerData.ManufacturerName"
				height="300"
				width="300"
			/>
		</figure>
	</div>
</template>

<style lang="scss">
@import "multisite/styles/settings/settings";
@import "multisite/styles/tools/tools";

.c-manufacturer-image {
	padding: 0 12px 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 634px;
	height: 634px;
	background-color: ds-color("bg", "decorative-1-muted");
	border-radius: 8px;

	@include t-respond-to-max("medium") {
		width: 100%;
		height: 300px;
		max-height: 100%;
		padding: 0;
	}

	&--basket {
		width: 100%;
		height: 300px;
		max-height: 100%;
		padding: 0;
	}

	&__figure {
		margin: 0;
		overflow: hidden;
		padding: 0 10px;
		mix-blend-mode: multiply;
		filter: brightness(105%);
	}

	&__logo {
		display: block;
		width: 100%;
		-o-object-fit: contain;
		object-fit: contain;

		.c-manufacturer-image--basket & {
			height: auto;
		}
	}
}
</style>
